import { ReactComponent as Icon } from 'assets/menuWide/betFinder.svg'
import React from 'react'

export default function BetFinder(props: any) {
  return (
    <Icon {...props} />
  )
}